import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';

class Logout extends Component {
    constructor(props) {
        super(props);
        //server.logout();
    }
    componentDidMount(){
        this.props.onLogout();
    }

    render() {
        return (
            <Redirect exact to='/'/>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onLogout: () => dispatch(actions.logout())
    }
}

export default connect(null, mapDispatchToProps)(Logout);